export enum VideoProvider {
    YouTube = 'youtube',
}
